import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'
import {
  DashboardDiagnosticTriggerRequestSchema,
  type DashboardDiagnosticTriggerRequestEntity
} from '@/core/infrastructure/schemas/dashboard/DashboardDiagnosticTriggerRequestSchema.ts'

/**
 * Requête pour déclencher un diagnostic
 */
export class DashboardDiagnosticTriggerRequest {
  readonly schoolClassroomId: number
  readonly triggerTime: Date

  constructor(triggerRequest: DashboardDiagnosticTriggerRequestEntity) {
    this.schoolClassroomId = triggerRequest.schoolClassroomId
    this.triggerTime = new Date(triggerRequest.triggerTime)
  }

  public static create(data: unknown): DashboardDiagnosticTriggerRequest {
    return EntityValidator.validateAndCreate(
      DashboardDiagnosticTriggerRequestSchema,
      data,
      DashboardDiagnosticTriggerRequest,
      'DashboardDiagnosticTriggerRequest'
    )
  }

  public toApiPayload() {
    return {
      schoolClassroomId: this.schoolClassroomId,
      triggerTime: this.triggerTime.toISOString()
    }
  }
}
